/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import fetch from "../../clients/web-app-bff-api-client";
import type { Client, RequestConfig, ResponseErrorConfig } from "../../clients/web-app-bff-api-client";
import type { CloneFragmentDetailMutationRequest, CloneFragmentDetailMutationResponse, CloneFragmentDetailPathParams } from "../models/CloneFragmentDetail";

export function getCloneFragmentDetailUrl(id: CloneFragmentDetailPathParams["id"]) {
  const res = { method: 'POST', url: `/fragments/${id}/clone` as const }
  return res
}

/**
 * @summary Clone a fragment
 * {@link /fragments/:id/clone}
 */
export async function cloneFragmentDetail(id: CloneFragmentDetailPathParams["id"], data: CloneFragmentDetailMutationRequest, config: Partial<RequestConfig<CloneFragmentDetailMutationRequest>> & { client?: Client } = {}) {
  const { client: request = fetch, ...requestConfig } = config

  const requestData = data

  const res = await request<CloneFragmentDetailMutationResponse, ResponseErrorConfig<Error>, CloneFragmentDetailMutationRequest>({ method : "POST", url : getCloneFragmentDetailUrl(id).url.toString(), data : requestData, ... requestConfig })
  return res.data
}